const $ = require('jquery');
require('./iframe')
require('./gtmevent')
const config = require('./config');
const simengie = require('./simengie');

const container = $('.simulator-cntnr');

const instance = simengie.Engine(container, config);

instance.h.addHook(
    'step.render.after',
    function (args) {
        console.log(args);

        // Give current iframe content height to parent page
        window.iframeItem.sendDocumentHeight();
    }
);

instance.h.addHook('step.addErrorMessage.after', function (step) {
    // Give current iframe content height to parent page
    window.iframeItem.sendDocumentHeight();
});

instance.init();
